var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.isLittleDoctor
        ? _c(
            "div",
            {
              staticClass: "back-door-doctor",
              attrs: { title: "点击小箭头可折叠或收起小博士按钮" }
            },
            [
              _c("span", {
                class: _vm.foldBackDoor
                  ? "el-icon-arrow-left"
                  : "el-icon-arrow-right",
                staticStyle: { "margin-right": "2px" },
                on: {
                  click: function($event) {
                    _vm.foldBackDoor = !_vm.foldBackDoor
                  }
                }
              }),
              _vm._v(" "),
              _c("el-switch", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.foldBackDoor === false,
                    expression: "foldBackDoor === false"
                  }
                ],
                attrs: {
                  "active-text": "小博士开",
                  "inactive-text": "小博士关"
                },
                on: { change: _vm.setLittleDoctor },
                model: {
                  value: _vm.backDoor,
                  callback: function($$v) {
                    _vm.backDoor = $$v
                  },
                  expression: "backDoor"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShow,
            expression: "isShow"
          }
        ],
        attrs: { id: "toTop" },
        on: {
          click: function($event) {
            return _vm.toTop()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.notSubjectVisible,
            width: "360px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.notSubjectVisible = $event
            }
          }
        },
        [
          _c("p", { staticStyle: { "line-height": "1.5" } }, [
            _vm._v(
              "您的账号当前暂未绑定学科，可能导致您无法查看考试报告。详情请咨询管理员～"
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.notSubjectVisible = false
                    }
                  }
                },
                [_vm._v("\n        我知道了\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("yue-no-permission", { attrs: { item: _vm.permissionItem } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 